import ArrowLeft from "../../../../assets/icons/Arrow/ArrowLeft";
import AddressForm from "../../../../components/AddressForm/AddressForm";
import {
  addUserAddress,
  deleteUserAddress,
  editUser,
} from "../../../../services/userService";
import { UserAddress } from "../../../../store/slice/userSlice";
import { AppDispatch } from "../../../../store/store";
import "./AddressCards.scss";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

type Props = {
  address: UserAddress;
  onEdit: (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "isDefaultShipping" | "isDefaultBilling"
  ) => void;
  onDelete: (id: string) => void;
};

const Card: React.FC<Props> = ({ address, onEdit, onDelete }) => {
  const {
    id,
    fullName,
    addressLine1,
    addressLine2,
    city,
    postalCode,
    country,
    phone,
    isDefaultShipping,
    isDefaultBilling,
  } = address;

  const [isShipping, setIsShipping] = useState(isDefaultShipping);
  const [isBilling, setIsBilling] = useState(isDefaultBilling);

  const [canEdit, setCanEdit] = useState(false);

  return (
    <div className="address-card">
      <div className="address-details">
        <div className="address-info">
          <p>{fullName}</p>
          <p>{addressLine1}</p>
          <p>{addressLine2}</p>
          <p>{city}</p>
          <p>{postalCode}</p>
          <p>{country}</p>
          <p>{phone}</p>
        </div>
        {isShipping && (
          <p className="default-info">
            Ceci est votre adresse de livraison par défaut.
          </p>
        )}
        {isBilling && (
          <p className="default-info">
            Ceci est votre adresse de facturation par défaut.
          </p>
        )}
        {canEdit && (
          <div className="checkboxes">
            <label>
              <input
                type="checkbox"
                checked={isDefaultShipping}
                onChange={(e) => {
                  onEdit(e, "isDefaultShipping");
                  setIsShipping(e.target.checked);
                  setCanEdit(false);
                }}
              />
              Adresse de livraison par défaut.
            </label>
          </div>
        )}
        {canEdit && (
          <div className="checkboxes">
            <label>
              <input
                type="checkbox"
                checked={isDefaultBilling}
                onChange={(e) => {
                  onEdit(e, "isDefaultBilling");
                  setIsBilling(e.target.checked);
                  setCanEdit(false);
                }}
              />
              Adresse de facturation par défaut.
            </label>
          </div>
        )}
      </div>
      <div className="address-actions">
        <button onClick={() => setCanEdit(!canEdit)}>Modifier ✏️</button>
        <button onClick={() => onDelete(id)}>Supprimer 🗑️</button>
      </div>
    </div>
  );
};

const AddressCards = ({
  addressList,
  access_token,
}: {
  addressList: UserAddress[] | undefined;
  access_token: string | null;
}) => {
  const [displayAddAddress, setDisplayAddAddress] = useState(false);
  const dispatch = useDispatch<AppDispatch>();

  const handleEdit = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: "isDefaultShipping" | "isDefaultBilling"
  ) => {
    access_token &&
      dispatch(
        editUser({
          userInfo: {
            [type]: e.target.checked,
          },
          token: access_token,
        })
      );
  };

  const onDeleteAddress = (id: string) => {
    if (access_token) {
      const addressTarget = addressList?.find((address) => address.id === id);
      if (!addressTarget?.isDefaultShipping) {
        dispatch(deleteUserAddress({ id, token: access_token }));
      } else {
        toast.error(
          "Impossible de supprimer votre adresse de livraison par défaut"
        );
      }
    }
  };

  const onCreateAddress = (value: any) => {
    access_token &&
      dispatch(addUserAddress({ address: value, token: access_token }));
    setDisplayAddAddress(false);
  };

  return (
    <div className="card-address-container">
      {displayAddAddress ? (
        <>
          <div className="card-address-header">
            <ArrowLeft onClick={() => setDisplayAddAddress(false)} />
            <h2>Ajouter une adresse</h2>
          </div>
          <AddressForm
            onSubmit={onCreateAddress}
            onCancel={() => setDisplayAddAddress(false)}
            typeForm="create"
          />
        </>
      ) : (
        <>
          <h2>Mes adresses</h2>
          {addressList?.length
            ? addressList?.map((address, i) => (
                <Card
                  key={i}
                  address={address}
                  onDelete={onDeleteAddress}
                  onEdit={handleEdit}
                />
              ))
            : "Aucune adresse enregistré"}
          <div className="button-add">
            <button onClick={() => setDisplayAddAddress(true)}>
              Ajouter une nouvelle adresse
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AddressCards;
